/* eslint-disable react/jsx-key */
import { useContext } from "react";

import GetIcon from "Components/Global/Icons";

import { TableContext } from "../..";
import * as S from "../../styles";
import GlobalFilter from "../GlobalFilter";

import { useTheme } from "styled-components";

const TableHead = ({ headerHeight }) => {
  const theme = useTheme();

  const { headerGroups } = useContext(TableContext);

  const getSortClick = (column) => {
    return column.getHeaderProps(column.getSortByToggleProps())?.onClick;
  };

  const getSortIcons = (column) => {
    if (!column.isSorted)
      return (
        <S.SortIcons onClick={getSortClick(column)}>
          <GetIcon
            name="ChevronUp"
            color={theme.colors.primary.vividCerulean}
            size="xs"
          />
          <GetIcon
            name="ChevronDown"
            color={theme.colors.primary.vividCerulean}
            size="xs"
          />
        </S.SortIcons>
      );

    return (
      <GetIcon
        name={column.isSortedDesc ? "ChevronDown" : "ChevronUp"}
        color={theme.colors.primary.vividCerulean}
        size="xs"
        onClick={getSortClick(column)}
      />
    );
  };

  return (
    <S.TableHead>
      {headerGroups.map((headerGroup) => (
        <S.TableRow {...headerGroup.getHeaderGroupProps()}>
          {headerGroup.headers.map((column) => (
            <S.TableHeaderCell>
              <S.HeaderItem
                {...column.getHeaderProps({
                  style: {
                    height: "100%",
                    alignItems: column.alignItems
                      ? column.alignItems
                      : "flex-start",
                    justifyContent: column.noSearch ? "center" : "flex-end",
                  },
                })}
                align={column.alignItems}
              >
                <S.TextWrapper headerHeight={headerHeight}>
                  <p>{column.render("Header")}</p>
                  {!column.noSearch && getSortIcons(column)}
                </S.TextWrapper>
                {!column.noSearch && <GlobalFilter column={column} />}
              </S.HeaderItem>
            </S.TableHeaderCell>
          ))}
        </S.TableRow>
      ))}
    </S.TableHead>
  );
};

export default TableHead;
